// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#ff7171","root":"Loader_root__12Lrj"};